<form name="editForm" role="form" novalidate (ngSubmit)="save()" #editForm="ngForm">

    <div class="modal-header">
        <h4 class="modal-title" id="myLotLabel" jhiTranslate="inventoryManagerApp.lot.home.createOrEditLabel">Create or edit a Lot</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="clear()">&times;</button>
    </div>
    <div class="modal-body">
        <!-- FIXME
        <div class="mb-3" [hidden]="!lot.id">
            <label for="id" jhiTranslate="global.field.id">ID</label>
            <input type="text" class="form-control" id="id" name="id"
                   [(ngModel)]="lot.id" readonly />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.userId" for="field_userId">User Id</label>
            <input type="number" class="form-control" name="userId" id="field_userId"
                [(ngModel)]="lot.userId" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.eType" for="field_eType">E Type</label>
            <input type="text" class="form-control" name="eType" id="field_eType"
                [(ngModel)]="lot.eType" maxlength="15"/>
            <div [hidden]="!(editForm.controls.eType?.dirty && editForm.controls.eType?.invalid)">
                <small class="form-text text-danger"
                   [hidden]="!editForm.controls.eType?.errors?.maxlength" jhiTranslate="entity.validation.maxlength" translateValues="{ param: 15 }">
                   This field cannot be longer than 15 characters.
                </small>
            </div>
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.eId" for="field_eId">E Id</label>
            <input type="number" class="form-control" name="eId" id="field_eId"
                [(ngModel)]="lot.eId" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.locId" for="field_locId">Loc Id</label>
            <input type="number" class="form-control" name="locId" id="field_locId"
                [(ngModel)]="lot.locId" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.unitId" for="field_scaleId">Scale Id</label>
            <input type="number" class="form-control" name="unitId" id="field_scaleId"
                [(ngModel)]="lot.unitId" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.status" for="field_status">Status</label>
            <input type="number" class="form-control" name="status" id="field_status"
                [(ngModel)]="lot.status" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.sourceId" for="field_sourceId">Source Id</label>
            <input type="number" class="form-control" name="sourceId" id="field_sourceId"
                [(ngModel)]="lot.sourceId" />
        </div>
        <div class="mb-3">
            <label class="form-control-label" jhiTranslate="inventoryManagerApp.lot.notes" for="field_comments">Comments</label>
            <input type="text" class="form-control" name="notes" id="field_comments"
                [(ngModel)]="lot.notes" maxlength="255"/>
            <div [hidden]="!(editForm.controls.notes?.dirty && editForm.controls.notes?.invalid)">
                <small class="form-text text-danger"
                   [hidden]="!editForm.controls.notes?.errors?.maxlength" jhiTranslate="entity.validation.maxlength" translateValues="{ param: 255 }">
                   This field cannot be longer than 255 characters.
                </small>
            </div>
        </div>
        -->

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
            <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
        </button>
        <button type="submit" [disabled]="editForm.form.invalid || isSaving" class="btn btn-primary">
            <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
        </button>
    </div>
</form>
